import React, { useCallback, useState, useEffect, useRef } from 'react';
import QuestionElementPrompt from 'components/Questions/shared/QuestionElementPrompt';
import CheckboxGroup from 'components/shared/CheckboxGroup';
import CheckboxField from 'components/shared/CheckboxGroup/CheckboxField';
import ReactHtml from 'components/shared/ReactHtml';
import request from 'utils/request_ajax';
import { IMultipleSelectProps } from './types';

const MultipleSelect = ({ data, meta }) => {
  const initialLoad = useRef(true);
  const [answers, setAnswers] = useState(data?.givenAnswer || []);

  const renderChoice = (choice, index) => {
    return (
      <CheckboxField
        key={index}
        value={choice}
        checked={answers.includes(choice)}
        className="py-8 px-16"
      >
        <ReactHtml component="span">{choice}</ReactHtml>
      </CheckboxField>
    );
  };

  const updateAnswer = async element => {
    if (answers.includes(element.target.value)) {
      setAnswers(answers.filter(item => item !== element.target.value));
    } else {
      const allAnswerOptions = data.choices;
      const newAnswers = allAnswerOptions.filter(
        answerOption =>
          answers.includes(answerOption) ||
          element.target.value === answerOption,
      );
      setAnswers(newAnswers);
    }
  };

  const updateRemoteAnswer = useCallback(
    async value => {
      try {
        await request.postJSON(meta.saveUrl, {
          answer: value,
          question_id: data?.questionId,
        });
      } catch (error) {
        console.error(error);
      }
    },
    [data, meta],
  );

  useEffect(() => {
    if (initialLoad.current) {
      initialLoad.current = false;
      return;
    }
    updateRemoteAnswer(answers);
  }, [answers, updateRemoteAnswer]);

  if (!data || !meta) return null;

  return (
    <>
      <QuestionElementPrompt
        elementHeaderClass={meta.elementHeaderClass}
        questionType={data.questionType}
        isGradable={data.isGradable}
        isPractice={data.isPractice}
        labelErrorClass={meta.labelErrorClass}
        questionSubjectClass={meta.questionSubjectClass}
        required={data.required}
        subject={data.subject}
      />

      <div className="choices">
        <h4 className="question_instructions">
          {t('questions.types.multiple_select.lesson_instructions')}
        </h4>
        <CheckboxGroup
          name={`${data.questionId}-multiple-select`}
          onChange={updateAnswer}
          disabled={!!data.disabledText}
        >
          {data.choices.map((choice, index) => renderChoice(choice, index))}
        </CheckboxGroup>
      </div>
    </>
  );
};

MultipleSelect.propTypes = IMultipleSelectProps;

export default MultipleSelect;
